import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  backDrop: {
    width: '100%',
    height: '100%',
    background: 'transparent',
    backdropFilter: 'blur(2px)',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1301,
  },
}));
